<template>
  <div class="app-container mianInfo">
    <!-- <el-button
      type="primary"
      icon="el-icon-plus"
      @click="handleAdd"
      class="mb20"
      >新增模板</el-button
    > -->

    <el-table v-loading="loading" element-loading-text="加载中" :data="list">
      <el-table-column label="序号" type="index" align="center" prop="time" />
       <el-table-column label="模板名称" align="center" prop="msgName">
        <template slot-scope="scope">
          {{ scope.row.msgName  }}
        </template>
      </el-table-column>
      <el-table-column label="消息类型" align="center" prop="msgType">
        <template slot-scope="scope">
          {{ scope.row.msgType | getMsgType }}
        </template>
      </el-table-column>
      <el-table-column label="推送对象" align="center" prop="pushThe">
        <template slot-scope="scope">
          {{ scope.row.pushThe | getPushThe }}
        </template>
      </el-table-column>
      <el-table-column label="触发节点" align="center" prop="msgNode" />
      <el-table-column
        label="消息模板"
        align="center"
        prop="msgTemplate"
        width="340"
      >
        <template slot-scope="scope">
          {{ scope.row.msgTemplate }}
        </template>
      </el-table-column>
      <el-table-column
        label="启用/关闭"
        align="center"
        prop="isEnable"
        width="200"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isEnable"
            active-value="1"
            inactive-value="0"
            @change="changeSwitch(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="添加人"
        align="center"
        prop="createBy"
      ></el-table-column>
      <el-table-column
        label="添加时间"
        align="center"
        prop="createTime"
      ></el-table-column>
      <!-- <el-table-column label="操作" align="center" class-name="small-padding fixed-width" >
        <template slot-scope="scope">
          <el-button size="small" plain type="primary" @click="handleEdit(scope.row)" >编辑</el-button >
        </template>
      </el-table-column> -->
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageQuery.pageNum"
      :limit.sync="pageQuery.pageSize"
      @pagination="getBusinessMsgList"
    />

    <el-dialog
      :title="addDialogTit"
      :visible.sync="dialogShow"
      width="600px"
      append-to-body
    >
      <el-form
        ref="form"
        :model="form"
        size="mini"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="消息类型:" prop="msgType">
          <el-select
            filterable
            v-model="form.msgType"
            placeholder="请选择消息类型"
            clearable
          >
            <el-option
              v-for="(item, index) in msgTypeList"
              :key="index"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="触发节点:" prop="msgNode">
          <el-input v-model="form.msgNode" placeholder="请输入触发节点" />
        </el-form-item>
        <el-form-item label="推送对象:" prop="pushThe"> 发布者 </el-form-item>
        <el-form-item label="消息参数:" prop="givenParam">
          <div class="msgParam">
            <div class="actName">赛事名称: ${actName}</div>
            <div class="name">姓名: ${Name}</div>
          </div>
        </el-form-item>
        <el-form-item label="消息模板" prop="msgTemplate">
          <el-input
            type="textarea"
            maxlength="100"
            placeholder="请输入内容"
            show-word-limit
            v-model="form.msgTemplate"
            :autosize="{ minRows: 4, maxRows: 4 }"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  businessMsgList,
  businessMsg,
  businessMsgUpdateIsEnable,
} from "@/api/sportManage/basic";
export default {
  name: "messageModel",
  data() {
    return {
      pageQuery: {
        pageNum: 1,
        pageSize: 10,
        time: [],
      },
      list: [],
      total: 0,
      loading: false,
      dialogShow: false,
      form: {},
      msgTypeList: [
        {
          name: "小程序消息",
          value: 3,
        },
        // {
        //   name: "短信消息",
        //   value: 2,
        // },
        // {
        //   name: "微信消息",
        //   value: 3,
        // },
        // {
        //   name: "后台消息",
        //   value: 4,
        // },
      ],
      msgNodeSelect: [],
      rules: {
        msgType: [
          { required: true, message: "请选择消息类型", trigger: "blur" },
        ],
        msgNode: [
          { required: true, message: "请选择消息节点", trigger: "change" },
        ],
        // pushThe: [
        //   { required: true, message: "请选择推送对象", trigger: "change" },
        // ],
        msgTemplate: [
          { required: true, message: "请输入消息模板", trigger: "change" },
        ],
      },
      addDialogTit: "",
    };
  },
  created() {
    this.getBusinessMsgList();
  },
  methods: {
    async getBusinessMsgList() {
      let res = await businessMsgList({
        ...this.pageQuery,
      });
      if (res.code === 200) {
        this.list = res.data.list;
        this.total = res.data.total;
        console.log(res);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data = {
            ...this.form,
            pushThe: 1,
          };
          console.log(data);
          // let res = null;
          // if (data.id) {
          //   // 编辑
          //   res = await deviceTypeEdit(data);
          // } else {
          //   // 增加
          //   res = await businessMsg(data);
          // }
          // if (res.code === 200) {
          //   this.$message({
          //     message: res.msg,
          //     type: "success",
          //   });
          //   this.dialogShow = false;
          //   this.getBusinessMsgList();
          // } else {
          //   this.$message({
          //     message: res.msg,
          //     type: "error",
          //   });
          // }
        } else {
          return false;
        }
      });
    },
    // 新增
    handleAdd() {
      this.dialogShow = true;
      this.form = {};
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogShow = false;
    },
    async changeSwitch(row) {
      let res = await businessMsgUpdateIsEnable({
        msgId: row.msgId,
        isEnable: row.isEnable,
      });
      if (res.code === 200) {
        this.getBusinessMsgList();
      }
    },
    // 变更触发节点
    msgNodeBind(e) {
      // this.pushTheVal = ''
      // this.form.pushThe = ''
      // if(e == 'N001' || e == 'N002' || e == 'N003' || e == 'N004' || e == 'N007' || e == 'N008'){
      //   this.form.pushThe = 1
      //   this.pushTheVal = '发布者'
      // } else if(e == 'N005' || e == 'N006' || e == 'N009' || e == 'N010'){
      //   this.form.pushThe = 2
      //   this.pushTheVal = '参与者'
      // } else if(e == 'N011' || e == 'N012'){
      //   this.form.pushThe = 3
      //   this.pushTheVal = '发布者、参与者'
      // }
    },
    //输入参数
    choose(e) {
      console.log(e);
    },
  },
  filters: {
    getMsgType(type) {
      switch (type) {
        case 1:
          return "系统消息";
        case 2:
          return "短信消息";
        case 3:
          return "微信消息";
        case 4:
          return "后台系统消息";
        default:
          return "暂无处理";
      }
    },
    getPushThe(value) {
      switch (value) {
        case "1":
          return "用户";
        case "2":
          return "主理人";
        case "3":
          return "商户";
        case "4":
          return "系统管理员";
        default:
          return "暂无处理";
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../assets/styles/common.scss";
.msgParam {
  display: flex;
  align-items: center;
  .name {
    margin-left: 42px;
  }
}
.msgDataStyle {
  display: flex;
}

.tips {
  font-size: 12px;
  color: red;
}

.blue {
  color: #2979ff;
}
</style>
